export function deletePaymentChannelV4(send) {
  return (payeeId, paymentChannelId, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}/paymentChannels/{paymentChannelId}',
        pathParameters: { payeeId, paymentChannelId },
        type: 'delete',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
